import { FC, useContext, useMemo } from 'react';
import { Guage } from '../../themed/charts';

import Conditional from '../../common/conditional';
import RiskRatingContext from '../../../context/useRiskRatingContext';

import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';

interface RiskRatingProps {
	data: any[];
}

const RiskRating: FC<RiskRatingProps> = ({ data }) => {
	const riskContext = useContext(RiskRatingContext);

	const getAnomalyBreakdown = (): models.GuageProps => {
		const breakdown: models.AnomalyBreakdown = utils.getRiskRatingData(data);

		const total: number = breakdown.breakdownData.reduce((a, c) => a + c, 0);
		const percentages: number[] = breakdown.breakdownData.map((v) => v / total);

		const majorIndex: number = breakdown.labels.findIndex((l) => l === 'major');
		const minorIndex: number = breakdown.labels.findIndex(
			(l) => l === 'moderate'
		);
		const actualIndex: number = percentages[majorIndex]
			? majorIndex
			: minorIndex;

		const ratingToPercentage: number = percentages[actualIndex] * 100;
		riskContext.setRiskRating(ratingToPercentage);

		return {
			percent: percentages[actualIndex],
			colors: breakdown.backgroundColor,
			textColor: breakdown.backgroundColor[actualIndex],
			nrOfLevels: breakdown.labels.length,
			arcsLength: [0.3, 0.5, 0.2],
			style: { height: 250, width: 500 },
		};
	};

	// eslint-disable-next-line
	const breakdown = useMemo(getAnomalyBreakdown, [data]);

	return (
		<Conditional isVisible={data.length > 0}>
			<Guage {...breakdown} />
		</Conditional>
	);
};

export default RiskRating;
